import { tsrClient } from '@/libs/ts-rest/ts-client';
import { createListProductFiltersQueryOptions } from '@/modules/products/react-query';

export const useListProductFiltersQuery = () => {
	const queryOptions = createListProductFiltersQueryOptions();
	const productFilterListQueryResult = tsrClient.web.products.listFilters.useQuery(queryOptions);

	return productFilterListQueryResult;
};